import React from 'react';
import { useEditorPreview } from '../contexts/EditorContext';
export function Pending({
  label,
  className = ''
}: {
  label: string;
  className?: string;
}) {
  const editor = useEditorPreview();
  if (!editor) return null;
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-sm border border-dashed border-goldDark bg-[#FFF4CC] px-1.5 py-0.5 font-sans text-[10px] font-bold uppercase tracking-wide text-[#6B4E00] ${className}`} title="Set this value in data/config.ts" data-id="element-6" data-mp="1p6mzj1bl71vs">
      Pending · {label}
    </span>;
}